module.exports = __webpack_public_path__ + "static/media/nurse.38dec0ed.jpg";